import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiK8sInstallerConfigTemplateActions = ActionsSet.make<
  DataKeys.KaapiK8sInstallerConfigTemplates
>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiK8sInstallerConfigTemplates],
  cacheKey: DataKeys.KaapiK8sInstallerConfigTemplates,
})

export const listKaapiK8sInstallerConfigTemplates = kaapiK8sInstallerConfigTemplateActions.add(
  new ListAction<DataKeys.KaapiK8sInstallerConfigTemplates, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi K8sInstallerConfigTemplates', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiK8sInstallerConfigTemplates)
    },
  ),
)
